import { useState, useEffect } from 'react';
import { MOBILE_BREAKPOINT } from '../config';

function useIsMobile(mobileBreakpoint: number = MOBILE_BREAKPOINT): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth <= mobileBreakpoint);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= mobileBreakpoint);
    };

    window.addEventListener('resize', handleResize);

    // Call handleResize immediately to set initial state
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [mobileBreakpoint]);

  return isMobile;
}

export default useIsMobile;
